{
  "locale": "de",
  "languages": {
    "aa": "Afar",
    "ab": "Abchasisch",
    "ae": "Awestisch",
    "af": "Afrikaans",
    "ak": "Akan",
    "am": "Amharisch",
    "an": "Aragonesisch",
    "ar": "Arabisch",
    "as": "Assamesisch",
    "av": "Awarisch",
    "ay": "Aymara",
    "az": "Aserbaidschanisch",
    "ba": "Baschkirisch",
    "be": "Weißrussisch",
    "bg": "Bulgarisch",
    "bh": "Bihari",
    "bi": "Bislama",
    "bm": "Bambara",
    "bn": "Bengalisch",
    "bo": "Tibetisch",
    "br": "Bretonisch",
    "bs": "Bosnisch",
    "ca": "Katalanisch",
    "ce": "Tschetschenisch",
    "ch": "Chamorro",
    "co": "Korsisch",
    "cr": "Cree",
    "cs": "Tschechisch",
    "cu": "Kirchenslawisch",
    "cv": "Tschuwaschisch",
    "cy": "Walisisch",
    "da": "Dänisch",
    "de": "Deutsch",
    "dv": "Dhivehi",
    "dz": "Dzongkha",
    "ee": "Ewe",
    "el": "Griechisch",
    "en": "Englisch",
    "eo": "Esperanto",
    "es": "Spanisch",
    "et": "Estnisch",
    "eu": "Baskisch",
    "fa": "Persisch",
    "ff": "Fulfulde",
    "fi": "Finnisch",
    "fj": "Fidschi",
    "fo": "Färöisch",
    "fr": "Französisch",
    "fy": "Westfriesisch",
    "ga": "Irisch",
    "gd": "Schottisch-Gälisch",
    "gl": "Galicisch",
    "gn": "Guarani",
    "gu": "Gujarati",
    "gv": "Manx",
    "ha": "Hausa",
    "he": "Hebräisch",
    "hi": "Hindi",
    "ho": "Hiri-Motu",
    "hr": "Kroatisch",
    "ht": "Haitianisch",
    "hu": "Ungarisch",
    "hy": "Armenisch",
    "hz": "Herero",
    "ia": "Interlingua",
    "id": "Indonesisch",
    "ie": "Interlingue",
    "ig": "Igbo",
    "ii": "Yi",
    "ik": "Inupiaq",
    "io": "Ido",
    "is": "Isländisch",
    "it": "Italienisch",
    "iu": "Inuktitut",
    "ja": "Japanisch",
    "jv": "Javanisch",
    "ka": "Georgisch",
    "kg": "Kikongo",
    "ki": "Kikuyu",
    "kj": "Kwanyama",
    "kk": "Kasachisch",
    "kl": "Grönländisch",
    "km": "Kambodschanisch",
    "kn": "Kannada",
    "ko": "Koreanisch",
    "kr": "Kanuri",
    "ks": "Kashmiri",
    "ku": "Kurdisch",
    "kv": "Komi",
    "kw": "Kornisch",
    "ky": "Kirgisisch",
    "la": "Latein",
    "lb": "Luxemburgisch",
    "lg": "Luganda",
    "li": "Limburgisch",
    "ln": "Lingála",
    "lo": "Laotisch",
    "lt": "Litauisch",
    "lu": "Kiluba",
    "lv": "Lettisch",
    "mg": "Malagassi",
    "mh": "Marschallesisch",
    "mi": "Maori",
    "mk": "Mazedonisch",
    "ml": "Malayalam",
    "mn": "Mongolisch",
    "mr": "Marathi",
    "ms": "Malaiisch",
    "mt": "Maltesisch",
    "my": "Birmanisch",
    "na": "Nauruisch",
    "nb": "Bokmål",
    "nd": "Nord-Ndebele",
    "ne": "Nepali",
    "ng": "Ndonga",
    "nl": "Niederländisch",
    "nn": "Nynorsk",
    "no": "Norwegisch",
    "nr": "Süd-Ndebele",
    "nv": "Navajo",
    "ny": "Chichewa",
    "oc": "Okzitanisch",
    "oj": "Ojibwa",
    "om": "Oromo",
    "or": "Oriya",
    "os": "Ossetisch",
    "pa": "Panjabi",
    "pi": "Pali",
    "pl": "Polnisch",
    "ps": "Paschtunisch",
    "pt": "Portugiesisch",
    "qu": "Quechua",
    "rm": "Rätoromanisch",
    "rn": "Kirundi",
    "ro": "Rumänisch",
    "ru": "Russisch",
    "rw": "Ruandisch",
    "sa": "Sanskrit",
    "sc": "Sardisch",
    "sd": "Sindhi",
    "se": "Nordsamisch",
    "sg": "Sango",
    "si": "Singhalesisch",
    "sk": "Slowakisch",
    "sl": "Slowenisch",
    "sm": "Samoanisch",
    "sn": "Shona",
    "so": "Somali",
    "sq": "Albanisch",
    "sr": "Serbisch",
    "ss": "Siswati",
    "st": "Sesotho",
    "su": "Sundanesisch",
    "sv": "Schwedisch",
    "sw": "Swahili",
    "ta": "Tamil",
    "te": "Telugu",
    "tg": "Tadschikisch",
    "th": "Thailändisch",
    "ti": "Tigrinya",
    "tk": "Turkmenisch",
    "tl": "Tagalog",
    "tn": "Setswana",
    "to": "Tongaisch",
    "tr": "Türkisch",
    "ts": "Xitsonga",
    "tt": "Tatarisch",
    "tw": "Twi",
    "ty": "Tahitisch",
    "ug": "Uigurisch",
    "uk": "Ukrainisch",
    "ur": "Urdu",
    "uz": "Usbekisch",
    "ve": "Thsivenda",
    "vi": "Vietnamesisch",
    "vo": "Volapük",
    "wa": "Wallonisch",
    "wo": "Wolof",
    "xh": "isiXhosa",
    "yi": "Jiddisch",
    "yo": "Yoruba",
    "za": "Zhuang",
    "zh": "Chinesisch",
    "zu": "isiZulu"
  }
}
